import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { CMDSpLastSeenRank, ICommand } from '../../live';
import { AbstractHandler } from '../AbstractHandler';
import { promotionToolSliceActions } from '../../../../modules/main/slice/promotiontool/promotionTool';

export class CMDSpLastSeenRankHandler extends AbstractHandler {
    _command: CMDSpLastSeenRank;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpLastSeenRank;
    }

    handle(dispatch: Dispatch<AnyAction>): void {
        const cmd = this._command;
        console.log(
            `command::handler::${cmd.getCmdName()}::${cmd.toString()}`,
            cmd
        );
        dispatch(promotionToolSliceActions.updateLastSeenRank(cmd.Rank));
    }
}
